import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgEye2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "m8.679 30.234-.111-.226.113-.226a23.68 23.68 0 0 1 29.672-11.657l-3.8 3.8A8.9 8.9 0 0 0 30 20.644a9.025 9.025 0 0 0-9.009 9.022 8.93 8.93 0 0 0 1.273 4.549l-5.354 5.354a23.8 23.8 0 0 1-8.23-9.335zm17.38.185a3.994 3.994 0 0 1 4.7-4.7zM12.686 50.862l5.085-5.085 3.8-3.8 4.329-4.324 3.978-3.977L34 29.546l3.978-3.978 5.048-5.048 3.6-3.6 4.245-4.245-3.531-3.537-5.188 5.187A28.64 28.64 0 0 0 4.21 27.556L3 29.992l1.194 2.444a28.75 28.75 0 0 0 9.119 10.728l-4.162 4.162zM55.8 27.722a28.7 28.7 0 0 0-5.4-7.509l-3.536 3.536a23.6 23.6 0 0 1 4.447 6.173l.11.224-.113.226a23.64 23.64 0 0 1-21.172 13.2h-.1a23 23 0 0 1-2.8-.192l-4.256 4.256a28.2 28.2 0 0 0 7.061.937h.113A28.61 28.61 0 0 0 55.787 32.6L57 30.164z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEye2);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
